import { DateTime } from 'luxon';
import * as React from 'react';

import CarIcon from 'assets/illustrations/goals/goal-car.svg';
import GoalSavingsOtherIcon from 'assets/illustrations/goals/goal-custom.svg';
import HomeIcon from 'assets/illustrations/goals/goal-home.svg';
import EmergencyFundIcon from 'assets/illustrations/goals/goal-rainyday.svg';
import VacationIcon from 'assets/illustrations/goals/goal-vacation.svg';
import WeddingIcon from 'assets/illustrations/goals/goal-wedding.svg';

export type specificGoalType = {
  type: string;
  name: string;
  icon: any;
  dialogTitle: string;
};

export const goalTypes: specificGoalType[] = [
  {
    type: 'SAVE_FOR_EMERGENCY_FUND',
    name: 'Emergency Fund',
    icon: EmergencyFundIcon,
    dialogTitle: 'Create an Emergency Fund Goal',
  },
  {
    type: 'SAVE_FOR_CAR',
    name: 'Car',
    icon: CarIcon,
    dialogTitle: 'Create a Car Goal',
  },
  {
    type: 'SAVE_FOR_VACATION',
    name: 'Vacation',
    icon: VacationIcon,
    dialogTitle: 'Create a Vacation Goal',
  },
  {
    type: 'SAVE_FOR_HOME',
    name: 'Home',
    icon: HomeIcon,
    dialogTitle: 'Create a Home Goal',
  },
  {
    type: 'SAVE_FOR_WEDDING',
    name: 'Wedding',
    icon: WeddingIcon,
    dialogTitle: 'Create a Wedding Goal',
  },
  {
    type: 'OTHER_SAVINGS_GOAL',
    name: 'Custom',
    icon: GoalSavingsOtherIcon,
    dialogTitle: 'Create a Custom Goal',
  },
];

export const goalTypeToMixpanelType = {
  SAVE_FOR_EMERGENCY_FUND: 'emergency',
  SAVE_FOR_HOME: 'house',
  SAVE_FOR_VACATION: 'vacation',
  SAVE_FOR_CAR: 'car',
  SAVE_FOR_WEDDING: 'wedding',
  OTHER_SAVINGS_GOAL: 'custom',
};

export type goalStateTypeProps = {
  type: specificGoalType; // entire object from list above ^^
  tabIndex: number;
  name: string;
  targetAmount: number;
  contributionAmount: number;
  savedSoFar: number;
  startDate: DateTime;
  targetDate: DateTime;
  includeInF2S: boolean;
  changesMade: boolean;
  canCalculate: boolean;
  contributions: { accountId?: string; amount?: number }[];
};

export const initialAddGoalState: goalStateTypeProps = {
  type: goalTypes[5], // entire object from list above ^^
  tabIndex: 0,
  name: '',
  targetAmount: 0,
  contributionAmount: 0,
  contributions: [{ accountId: undefined, amount: 0 }],
  savedSoFar: 0,
  startDate: DateTime.local().startOf('month'),
  targetDate: DateTime.local().plus({ years: 1 }).endOf('month'),
  includeInF2S: true,
  changesMade: false,
  canCalculate: false,

  // for dev
  // tabIndex: 1,
  // type: goalTypes[0],
  // name: 'name',
  // targetAmount: 200,
  // savedSoFar: 10,
  // contributionAmount: 3.85,
};

// @ts-expect-error FIXME TS7006
function calculateSideEffects(state, { payload }) {
  if (!state) return {};

  const sideEffects: any = {};
  if (payload.tabIndex && payload.tabIndex === 2 && state.targetAmount > 0 && state.canCalculate) {
    // if changing tabs
    const { targetAmount } = state;

    if (payload?.savedSoFar >= targetAmount) {
      sideEffects.contributionAmount = 0;
      sideEffects.targetDate = null;
    } else if (state.targetDate) {
      const numMonthsLeft = Math.ceil(state.targetDate.diff(state.startDate, 'months').months);
      sideEffects.contributionAmount =
        Math.ceil(((targetAmount - (payload?.savedSoFar || 0)) / numMonthsLeft) * 100) / 100;
    }
  }

  if (payload.tabIndex === 0) {
    sideEffects.madeChanges = false;
  }

  return sideEffects;
}

// @ts-expect-error FIXME TS7006
export function reduceAddGoal(state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.payload, madeChanges: true, ...calculateSideEffects(state, action) };
    case 'reset':
    case 'init':
      return initialAddGoalState;
    default:
      return state;
  }
}
export type contextTypes = {
  state: goalStateTypeProps;
  dispatch: React.Dispatch<any>;
  onSubmit: () => Promise<void> | void;
};

const defaultVals = {
  state: initialAddGoalState,
  dispatch: () => {},
  onSubmit: () => {},
};

const AddGoalContext = React.createContext<contextTypes>(defaultVals);
AddGoalContext.displayName = 'Add Goal Context';
export { AddGoalContext };
